import React from 'react';
import { Avatar, Grid } from "@mui/material"
import moment from 'moment';
import 'moment/locale/de-at';
import { CommentType } from '../../../api/projects-api';

type CommentPropsType = {
  comment: CommentType
}

export const Comment = React.memo((props: CommentPropsType) => {

  let commentText = props.comment.text
  let parser = new DOMParser()
  let htmlText = parser.parseFromString(commentText, 'text/html')
  let name
  

  console.log('NAME from props: ', props.comment.revisedBy.displayName)

  let divArr = htmlText.getElementsByTagName('div')
  if (divArr.length > 0) {
    let parentDiv = divArr[0]
    console.log('parentDiv ', parentDiv)
    // @ts-ignore
    let nameDiv = parentDiv.getElementsByClassName('data-name')
    console.log('nameDiv', nameDiv)
    if (nameDiv.length > 0) {
      let nameStr = nameDiv[0].getAttribute('data-name')
      let nameArr = nameStr?.split('/')
      name = nameArr?.join(' ')
      console.log('name: ', name)
      parentDiv.removeChild(nameDiv[0])
      console.log('htmlText', htmlText)
    }
    commentText = new XMLSerializer().serializeToString(htmlText)
  }
 

  function stringToColor(string: string) {
    let hash = 0
    let i
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash)
    }
  
    let color = '#'
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
    return color
  }
  
  function stringAvatar(name: string) {
   

    let arr = name.split(' ')
    let avatarName = ''
    if(arr.length === 1){
        avatarName = `${arr[0][0] + arr[0][1]}`
    } else {
      avatarName = `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
    }
    debugger
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: avatarName,
    }
  }

  let nameFromPros = name === undefined ? props.comment.revisedBy.displayName : name
  if(nameFromPros !== "TFS4JIRA") {
    return (
      <>
     
        <Grid container style={{ marginBottom: '10px' }} spacing={2}>
          <Grid item style={{ display: 'flex', justifyContent: 'center' }} xs={1}>
            {/* <Avatar sx={{ width: 32, height: 32 }} src={props.comment.revisedBy.imageUrl} /> */}
            <Avatar {...stringAvatar(nameFromPros)} />
          </Grid>
          <Grid item xs={11}>
            <div className="comment" >
              <span style={{ margin: '10px' }}>
                <b>{nameFromPros}</b> commented {moment(props.comment.revisedDate).calendar()}
              </span>
              <div dangerouslySetInnerHTML={{ __html: commentText }}>
              </div>
            </div>
          </Grid>
        </Grid>
      </>
    )
  }
  else {
    return (
      <></>
    )
  }
})